import {
  Component,
  OnInit,
  ViewEncapsulation,
  Inject,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { Principal } from "../models/principal";
import { PrincipalService } from "../services/principal.service";
import { LazyLoaderService } from "../services/lazy-loader.service";
import { Router, ActivatedRoute } from "@angular/router";
import { TermsService } from "../services/terms.service";
import { AuthenticationService } from "../services/authentication.service";
import { AppConstants } from "../app_setting/app-constants";
import { AlertComponent } from "../alert/alert.component";
import { LoginDialogComponent } from "../login-dialog/login-dialog.component";
import * as firebase from "firebase";
// import { MessagingService } from '../services/messaging.service';

declare var $: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  public principal: Principal[] = [];
  public terms: string = "";
  public showTerms: boolean = false;
  public isLogged: boolean = false;
  @ViewChild("alertModal") alertModal: AlertComponent;
  // message: any;

  constructor(
    private router: Router,
    public principalService: PrincipalService,
    private lazyLoaderService: LazyLoaderService,
    private termService: TermsService,
    public authService: AuthenticationService,
    private route: ActivatedRoute
  ) // private messagingService: MessagingService
  {}

  ngOnInit() {
    $(".modal-backdrop").remove();
    firebase.analytics().logEvent("landing_page");

    this.lazyLoaderService.loadScript(
      "assets/asset-landing-page/lib/jquery/jquery-migrate.min.js"
    );
    this.lazyLoaderService.loadScript(
      "assets/asset-landing-page/lib/bootstrap/js/bootstrap.bundle.min.js"
    );
    this.lazyLoaderService.loadScript(
      "assets/asset-landing-page/lib/easing/easing.min.js"
    );
    this.lazyLoaderService.loadScript(
      "assets/asset-landing-page/lib/mobile-nav/mobile-nav.js"
    );
    this.lazyLoaderService.loadScript(
      "assets/asset-landing-page/lib/wow/wow.min.js"
    );

    if (this.router.url == "/terms") {
      this.showTerms = true;
      this.termService.getTermsPage(
        (resp) => {
          if (resp.alert.code == 200) {
            this.terms = resp.data;
          }
        },
        (err) => {}
      );
    } else {
      this.showTerms = false;
      this.principal = this.principalService.getPrincipalHighlighted(
        (data) => {
          this.principal = data;
        },
        (err) => {
          console.log(err);
        }
      );
      this.isLogged = this.authService.isLogged();
    }
  }

  getQueryParamData(): void {
    this.route.queryParamMap.subscribe((params) => {
      const loginSession = params.get("session");
      if (
        loginSession !== null &&
        loginSession === AppConstants.SessionExpired
      ) {
        this.alertModal.show("", "Sesi anda telah habis");
      }
    });
  }

  ngAfterViewInit() {
    this.lazyLoaderService.loadScript("assets/asset-landing-page/js/main.js");
    // this.getQueryParamData();
  }
}
